export default __webpack_public_path__ + "static/media/english-to-thai-screenshot-01.2e330303.png";